const sessionExpiredModal = {
  title: "Session Expired",
  message: "Your session has expired due to inactivity. Please log in again to continue.",
  redirectNotice: "Redirecting to login page in 5 seconds...",
  goToLogin: "Go to Login",
};

export default sessionExpiredModal;
